const OPEN_EMBED_KEY = 'openApiEmbedMode'

export function getOpenEmbedModeFlag() {
  try {
    return sessionStorage.getItem(OPEN_EMBED_KEY) === '1'
  } catch (e) {
    return false
  }
}

export function setOpenEmbedModeFlag() {
  try {
    sessionStorage.setItem(OPEN_EMBED_KEY, '1')
  } catch (e) {
    /* ignore */
  }
}

export function clearOpenEmbedModeFlag() {
  try {
    sessionStorage.removeItem(OPEN_EMBED_KEY)
  } catch (e) {
    /* ignore */
  }
}



// WEBPACK FOOTER //
// ./src/utils/openEmbedSession.js